import { NavLink } from "react-router";
import { useLookupFondsQuery } from "../../stores/OkOkStore";
import type { Fond } from "../../types/Fond";
import { formatDate } from "../../tools/utils";
import { useState } from "react";
import Pager from "../Common/Pager";
import ProfilListItem from "../Common/ProfilListItem";
import ProfilDisplay from "../Common/ProfilDisplay";
import { useAuth } from "../../contexts/auth/useAuth";
import { roles } from "../../types/Users";
import { useTrads } from "../../contexts/trads/useTrads";

function FondsList({show_user}: {show_user?:boolean}) {
    const [params,setParams]=useState<Record<string, string>>({page:"0"});
    const { data, error, isLoading } = useLookupFondsQuery(params);
    const setPage=function(page:number){
        setParams({...params,page: page.toString()})
    }
    const {translate}=useTrads();

    const { hasRole,user } = useAuth();
    return (
 
            error ? (
               <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                
                <table className="table">
                <thead>
                    <tr>
                        <th>{translate('label_date_creation')}</th>
                        {show_user?<th>{translate('fond_user')}</th>:null}
                        <th>{translate('fond')}</th>
                        <th>{translate('fond_solde')}</th>
                        <th>{translate('fond_paye')}</th>
                        <th>{translate('fond_engage')}</th>
                        <th>{translate('fond_year')}</th>
                        <th>{translate('fond_publique')}</th>
                        <th>{translate('fond_perso')}</th>
                        <th>{translate('fond_statut')}</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                {data.data.map((fond:Fond) => (
                    <tr  key={fond.id}>
                        <td>{formatDate(fond.date_creation)} </td>
                        {show_user?
                        <td>
                            {fond.inscription? 
                                <ProfilDisplay inscription={fond.inscription} /> :
                                <ProfilListItem userid={fond.id_inscription} />
                            }    
                        </td>
                        :null}
                        
                        <td >
                            {fond.name} {((fond.type_frais?.length??0) == 0)?<i title={translate('fond_error_type_frais_requis')} className="bi bi-exclamation-triangle text-warning"></i>:null}  
                           
                        </td>
                        <td>{fond.solde}</td>
                        <td>{fond.real}</td>
                        <td>{fond.pending}</td>
                        <td>{fond.year}</td>
                        <td>{fond.publique?'Oui':'Non'}</td>
                        <td>{fond.perso?'Oui':'Non'}</td>
                        <td className={fond.publique?(fond.statut=="01_published"?"table-success":"table-danger"):undefined}>
                            {fond.publique?translate('fond_statut_'+fond.statut):'N/A'}
                        </td>
                        <td>
                            <NavLink to={`/fond/${fond.id.toString()}`}>
                                <span className="visually-hidden">{translate('btn_voir')}</span>
                                <i className="bi bi-eye-fill"></i>
                            </NavLink>
                        </td>
                       
                        <td>
                            {(hasRole(roles.Manager) || fond.id_inscription==user?.id)?
                            <NavLink to={`/fond/${fond.id.toString()}/edit`}>
                                <span className="visually-hidden">{translate('btn_edit')}</span>
                                <i className="bi bi-pencil-fill"></i>
                            </NavLink>
                            :null}
                        </td>

                    </tr>
                ))}
                </tbody>
                </table>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                </>
            ) : null
    );
}
export default FondsList;